import { useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Text } from "../UI";
import { CircleDiv } from "../components/Common";
import menuImg from "../assets/img/menu.svg";
import arrowImg from "../assets/img/arrow-right-outline.svg";
import { useTranslation } from "react-i18next";
import { publish } from "../utils/events";
import removeImg from "../assets/img/close-circle.svg";

const showDrawer = () => {
  publish("showDrawer");
};

const MobileHeader = ({
  userStore,
  tenantsStore,
  navigateTo,
  step,
  removeItem,
}) => {
  const [title, setTitle] = useState("");
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation("menu");

  useEffect(() => {
    i18n.changeLanguage(userStore.language);
  }, [userStore.language]);

  useEffect(() => {
    if (location.pathname.includes("/applies")) {
      setTitle("applies");
    } else if (location.pathname === "/tenant/messages") {
      setTitle("messages");
    } else if (
      location.pathname === "/tenant/messages" ||
      location.pathname === "/bedek/new-repair-page" ||
      location.pathname === "/tenant/new-repair-page"
    ) {
      setTitle("apply_repair");
    } else if (location.pathname === "/tenant/contacts") {
      setTitle("contacts");
    } else if (location.pathname === "/tenant/docs") {
      setTitle("docs");
    } else {
      if (!!navigateTo) {
        setTitle(navigateTo);
      } else {
        setTitle("lobby");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div
      style={{
        display: "flex",
        flexDercrion: "row",
        justifyContent: "space-between",
        backgroundColor: theme.color.primary,
        padding: 15,
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDercrion: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDercrion: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          {!!navigateTo ? (
            <img
              src={arrowImg}
              alt="navigate"
              style={{ height: 24, width: 24 }}
              onClick={() => {
                if (tenantsStore.selectedSiteSpace?.ISONLYBEDEK === "Y") {
                  location.pathname === "/bedek/mobile-new-defect"
                    ? navigate("/bedek/new-repair-page")
                    : navigate("/bedek/applies");
                } else {
                  location.pathname === "/bedek/mobile-new-defect"
                    ? navigate("/tenant/new-repair-page")
                    : navigate("/tenant/applies");
                }
              }}
            />
          ) : !!step ? (
            <div
              title="close"
              style={{
                mask: `url(${removeImg}) no-repeat center / contain`,
                backgroundColor: theme.color.white,
                width: 24,
                height: 24,
              }}
              onClick={() => {
                if (!!step) {
                  if (location.pathname.includes("/tenant")) {
                    navigate("/tenant/new-repair-page", { state: { step: 1 } });
                  } else {
                    navigate("/bedek/new-repair-page", { state: { step: 1 } });
                  }
                } else {
                  navigate(-1);
                }
              }}
            ></div>
          ) : (
            <img
              src={menuImg}
              alt="navigate"
              style={{ height: 24, width: 24 }}
              onClick={showDrawer}
            />
          )}
          {!step && (
            <Text.H4 color={theme.color.white} style={{ textAlign: "start" }}>
              {t(`${title}`)}
            </Text.H4>
          )}
        </div>
        {!step && (
          <CircleDiv
            backgroundColor={theme.color.primary}
            height={30}
            width={30}
            style={{ border: `1px solid ${theme.color.white}` }}
          >
            <Text.BB color={theme.color.white} style={{ textAlign: "center" }}>
              {userStore.userDetails?.NAME?.split(" ")
                .map((n) => n.slice(0, 1))
                .join("")}
            </Text.BB>
          </CircleDiv>
        )}
      </div>
    </div>
  );
};
export default inject("userStore", "tenantsStore")(observer(MobileHeader));
